import { createRoot } from 'react-dom/client'
import './design/tokens.css'
import './index.css'
import './theme-snaplayer.css'
import './design/stage-remap.css'
import './utils/quietConsole'
import './editor/utils/mutationObserverGuard'
import { initChunkErrorHandler, clearChunkErrorState } from './utils/chunkErrorHandler'
import { initSentry } from './lib/sentry'
import { initStageUi } from './design/stageUi'

// Stage UI (redesign) — reads ?ui= / localStorage and sets <html data-ui> before first paint.
initStageUi();

// Error monitoring (no-op until VITE_SENTRY_DSN is set).
initSentry();

// Initialize chunk error handling to auto-reload on stale deployments
initChunkErrorHandler();

// Clear error state on successful load
clearChunkErrorState();

// Track editor init time ASAP to suppress early dirty marks
if (typeof window !== 'undefined') {
  (window as any).__editorInitTime = Date.now();
}

const root = createRoot(document.getElementById("root")!);

// Legal terms must remain reachable even if authentication or an application data service is
// unavailable. Direct requests therefore avoid importing the Supabase-backed application shell.
if (window.location.pathname === '/terms') {
  void import('./pages/Terms').then(({ default: Terms }) => root.render(<Terms />));
} else {
  void import('./App.tsx').then(({ default: App }) => root.render(<App />));
}
